/**
 * Shared payload shaping for POST /api/trades/manual (Trade Wizard + Broker Sync).
 */

export function formatTradeForManualApi(trade) {
  return {
    ...(trade.id && { id: trade.id }),
    symbol: trade.symbol.trim().toUpperCase(),
    tradeType: trade.tradeType,
    quantity: parseFloat(trade.quantity),
    price: parseFloat(trade.price),
    exitPrice: trade.exitPrice !== '' && trade.exitPrice != null ? parseFloat(trade.exitPrice) : null,
    exitDate:
      trade.exitPrice !== '' && trade.exitPrice != null && trade.expiry && trade.expiry.trim()
        ? trade.expiry.trim()
        : null,
    tradeDate: trade.tradeDate,
    segment: trade.segment ? trade.segment.trim().toUpperCase() : null,
    expiry: trade.expiry || null,
    ...(trade.broker && { broker: trade.broker }),
    ...(trade.brokerTradeId && { brokerTradeId: String(trade.brokerTradeId) }),
    ...(trade.brokerOrderId && { brokerOrderId: String(trade.brokerOrderId) }),
  };
}

export function manualTradePayloadSignature(trade) {
  const p = formatTradeForManualApi(trade);
  return JSON.stringify({
    symbol: p.symbol,
    tradeType: p.tradeType,
    quantity: p.quantity,
    price: p.price,
    exitPrice: p.exitPrice,
    exitDate: p.exitDate,
    tradeDate: p.tradeDate,
    segment: p.segment,
    expiry: p.expiry,
    broker: p.broker || null,
    brokerTradeId: p.brokerTradeId || null,
    brokerOrderId: p.brokerOrderId || null,
  });
}

export function tradeRowPassesValidation(trade) {
  if (!trade.symbol?.trim() || !trade.quantity || !trade.price || !trade.tradeDate) return false;
  if (parseFloat(trade.quantity) <= 0 || Number.isNaN(parseFloat(trade.quantity))) return false;
  if (parseFloat(trade.price) <= 0 || Number.isNaN(parseFloat(trade.price))) return false;
  if (trade.exitPrice !== '' && trade.exitPrice != null) {
    const ep = parseFloat(trade.exitPrice);
    if (ep < 0 || Number.isNaN(ep)) return false;
    if (!trade.expiry || !String(trade.expiry).trim()) return false;
  }
  return true;
}
